import React from 'react';

function ProfileIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M11.976 8.752C14.3928 8.752 16.352 6.7928 16.352 4.376C16.352 1.9592 14.3928 0 11.976 0C9.55918 0 7.59998 1.9592 7.59998 4.376C7.59998 6.7928 9.55918 8.752 11.976 8.752Z'
				fill='#CF004F'
			/>
			<path
				d='M9.98398 10.5295H14.144C15.7858 10.5295 17.3603 11.1817 18.5213 12.3427C19.6822 13.5036 20.3344 15.0781 20.3344 16.7199V23.9999H3.79358V16.7199C3.79358 15.0781 4.44578 13.5036 5.60671 12.3427C6.76763 11.1817 8.34218 10.5295 9.98398 10.5295Z'
				fill='#CF004F'
			/>
		</svg>
	);
}

export default ProfileIcon;
